import { Construction } from "lucide-react";

export const ModuleNotBuilt = ({ name }) => (
  <div className="border-2 border-dashed border-soft-gray rounded-2xl p-16 text-center" data-testid="module-not-built">
    <Construction className="w-8 h-8 text-stranger-orange mx-auto mb-4" />
    <p className="text-xs font-bold tracking-[0.25em] uppercase text-stranger-orange mb-3">{name}</p>
    <h2 className="font-extrabold uppercase text-xl mb-2">Module Not Yet Built</h2>
    <p className="text-sm font-medium text-midnight-black/60 max-w-sm mx-auto">This section is planned but hasn't been implemented yet. Check back once it ships.</p>
  </div>
);
